import React, { useState, useContext, useEffect } from "react";
import { ProductContext } from "../../../stores/session";
import GenericPageContainer from "../../../GenericPageElements/GenericPageContainer";
import { Link } from "react-router-dom";
import hasPermission from "../../../helpers/permissions";
import useStatusFilter from "../../../components/bd-generics/hooks/useStatusFilter";
import StatusFilter from "../../../components/bd-generics/components/StatusFilter/StatusFilter";
import useSearch from "../../../components/bd-generics/hooks/useSeach";
import useWorkflow from "../../../components/bd-generics/hooks/useWorkflow";
import SearchBar from "../../../components/bd-generics/components/SearchBar/SearchBar";
import usePurchase from "../../../components/bd-generics/hooks/usePurchase";
import PurchaseButton from "../../../components/bd-generics/components/PurchaseButton";
import useFileDate from "../../../components/bd-generics/hooks/useFileDate";
import FileDateSelect from "../../../components/bd-generics/components/FileDateSelect";
import useExclude from "../../../components/bd-generics/hooks/useExclude";
import ExcludeSelect from "../../../components/bd-generics/components/ExcludeSelect";
import useWholesaler from "../../../components/bd-generics/hooks/useWholesaler";
import WholesalerSelect from "../../../components/bd-generics/components/WholesalerSelect";
import useCotDate from "../../../components/bd-generics/hooks/useCotDate";
import CotDateSelect from "../../../components/bd-generics/components/CotDateSelect";
import useStatus from "../../../components/bd-generics/hooks/useStatus";
import StatusSelect from "../../../components/bd-generics/components/StatusSelect";
import AdcSelect from "../../../components/bd-generics/components/AdcSelect";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";
import { ExperianEvidenceTable, GoogleOpeningHoursTable, GovernmentEvidenceTable, MarketingEvidenceTable, MatchingSpidDataTable } from "../../../components/bd-generics/components/EvidenceTables";
import './vacantCOTAlerts.scss'
import PropertyMap from "../../../components/property-map/property-map";

export default function VacantCOTAlertsSearchWorflow() {
    const { translations, isWorkflow, navigationPath, permissionPrefix, isBdPlus, uuid } = useContext(ProductContext)
    const [spid, setSpid] = useState('');
    const [selectedAdcGroup, setSelectedAdcGrouup] = useState('')
    const { data, setData, getData, loading: searchLoading, purchasable, setPurchasable } = useSearch(spid, setSpid);
    const { getWholesalers, wholesalers, selectedWholesaler, setSelectedWholesaler } = useWholesaler();
    const { getFileDates, fileDates, selectedFileDate, setSelectedFileDate } = useFileDate()
    const { workflowCounts, getWorkflowCounts, selectedStatus, setSelectedStatus } = useStatusFilter({selectedWholesaler, selectedAdcGroup, selectedFileDate})
    const { getWorkflowItems, workflowItems, loading: workflowLoading, getWorkflowLast, getWorkflowNext, _cur } = useWorkflow({ spid, setSpid, setData, setPurchasable, selectedWholesaler, selectedAdcGroup, selectedFileDate, selectedStatus });
    const { purchaseCustomer, loading: purchaseLoading } = usePurchase({ data, getData, getWorkflowItems, getWorkflowCounts })
    const { excludeCustomer, loading: excludeLoading } = useExclude(data, getData, getWorkflowItems)
    const { updateCotDate } = useCotDate(data, setData);
    const { updateStatus } = useStatus(data, setData)
    // if (productId !== "vacant_cot_alerts") return <></>

    useEffect(() => {
        getWholesalers();
        getFileDates();
    }, [])

    useEffect(() => {
        if (isWorkflow) {
            getWorkflowItems()
        } else {
            setData({})
            setSpid('')
        }
    }, [isWorkflow])

    useEffect(() => {
        if (data.status && data?.status !== selectedStatus) {
            getWorkflowCounts()
            getWorkflowItems()
        }
    }, [spid])

    useEffect(() => {
        getWorkflowCounts()
        getWorkflowItems()
    }, [selectedWholesaler, selectedAdcGroup, selectedFileDate, selectedStatus])

    return (
        <GenericPageContainer
            title={
                translations['module_title']
                + ' - '
                + (isWorkflow ? 'Workflow' : 'Search')
                + (isBdPlus ? ' Plus' : '')
            }
            className={'vacantCOTAlerts'}
            containerWidth={'92vw'}
            titleRight={
                <div>
                    <Link className="navigate" to={`/portal/${navigationPath}`}>
                        To Overview
                    </Link>
                    {
                        isWorkflow ?
                            <Link className="navigate" to={`/portal/${navigationPath}/search`}>
                                To Search
                            </Link>
                            :
                            (hasPermission(permissionPrefix, 'WORKFLOW')) &&
                            <Link className="navigate" to={`/portal/${navigationPath}/workflow`}>
                                To Workflow
                            </Link>
                    }
                    {
                        hasPermission(permissionPrefix, 'DASHBOARD') &&
                        <Link className="navigate" to={`/portal/${navigationPath}/dashboard`}>
                            To Dashboard
                        </Link>
                    }
                </div>
            }
        >
            <div className="grid grid-gap-15">
                {isWorkflow &&
                    <StatusFilter
                        statusCounts={workflowCounts}
                        selectedStatus={selectedStatus}
                        setSelectedStatus={setSelectedStatus}
                    />
                }
                <div className="spid-data-container">
                    <div className="spid-row">
                        <SearchBar
                            loading={searchLoading || workflowLoading}
                            spid={spid}
                            setSpid={setSpid}
                            getData={getData}
                            getWorkflowLast={getWorkflowLast}
                            _cur={_cur}
                            workflowItems={workflowItems}
                            getWorkflowNext={getWorkflowNext}
                        />
                        <StatusSelect
                            data={data}
                            updateStatus={updateStatus}
                        />
                        <GenericDataRow title={"Assigned to"} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.assigned_to}
                        </GenericDataRow>
                        <PurchaseButton
                            loading={purchaseLoading}
                            purchasable={purchasable}
                            data={data}
                            _cur={_cur}
                            selectedWholesaler={selectedWholesaler}
                            purchaseCustomer={purchaseCustomer}
                        />
                        <ExcludeSelect
                            loading={excludeLoading}
                            purchasable={purchasable}
                            data={data}
                            _cur={_cur}
                            selectedWholesaler={selectedWholesaler}
                            excludeCustomer={excludeCustomer}
                        />
                    </div>
                    <GenericDataRow title={translations['Client_Address']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                        {data.SPID_Address}
                    </GenericDataRow>
                    <FileDateSelect
                        fileDates={fileDates}
                        selectedFileDate={selectedFileDate}
                        setSelectedFileDate={setSelectedFileDate}
                        data={data}
                    />
                    <GenericDataRow title={translations['cmos_uprn_address']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                        {data.CMOS_UPRN_Single_Line}
                    </GenericDataRow>
                    <AdcSelect
                        data={data}
                        selectedAdcGroup={selectedAdcGroup}
                        setSelectedAdcGrouup={setSelectedAdcGrouup}
                    />
                    <GenericDataRow title={translations['cmos_voa_address']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                        {data.CMOS_VOA_Single_Line}
                    </GenericDataRow>
                    <WholesalerSelect
                        data={data}
                        wholesalers={wholesalers}
                        selectedWholesaler={selectedWholesaler}
                        setSelectedWholesaler={setSelectedWholesaler}
                    />
                    {
                        isBdPlus ?
                            <div className="grid grid-columns-4 grid-gap-10">
                                <GenericDataRow title={translations['occupier_score']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                                    {data.Occupier_Score}
                                </GenericDataRow>
                                <GenericDataRow title={translations['company_name']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }}>
                                    {data.Company_Name}
                                </GenericDataRow>
                                <GenericDataRow title={translations['occupier_plus_score']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }}>
                                    {data.CAIS_Occupier_Score_Plus}
                                </GenericDataRow>
                                <GenericDataRow title={translations['company_plus_name']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                                    {data.Company_Name_bd_plus}
                                </GenericDataRow>
                            </div>
                            :
                            <div className='occupier-score-and-name-row-container'>
                                <div className="occupier-score-name-rows">
                                    <GenericDataRow title={translations['occupier_score']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                                        {data.Occupier_Score}
                                    </GenericDataRow>
                                    <GenericDataRow title={translations['company_name']} contentColour={'var(--white)'}
                                        style={{ marginRight: '-5px' }}
                                        contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }}
                                    >
                                        {data.Company_Name}
                                    </GenericDataRow>
                                </div>
                                <GenericDataRow title={translations['occupier_plus_score']} contentColour={'var(--white)'}
                                    style={{ marginLeft: '5px' }}
                                    contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }}
                                >
                                    {data.CAIS_Occupier_Score_Plus}
                                </GenericDataRow>
                            </div>
                    }
                    <CotDateSelect
                        data={data}
                        updateCotDate={updateCotDate}
                    />
                    <div className='title-owner-row'>
                        <GenericDataRow title={translations['title_deed_owner']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.LR_Name_No}
                        </GenericDataRow>
                        <GenericDataRow title={translations['title_deed_address']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.LR_Address}
                        </GenericDataRow>
                    </div>
                    <div className="voa-row">
                        <GenericDataRow title={translations['voa_number']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.Voa_Number}
                        </GenericDataRow>
                        <GenericDataRow title={translations['liable_party_1']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.Liable_Party_1}
                        </GenericDataRow>
                        <GenericDataRow title={translations['liable_party_2']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.Liable_Party_2}
                        </GenericDataRow>
                        <GenericDataRow title={translations['liable_party_3']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.Liable_Party_3}
                        </GenericDataRow>
                        <GenericDataRow title={translations['liable_from_date']} contentColour={'var(--white)'} contentStyle={{ backgroundColor: '#ececec', fontSize: '13px' }} >
                            {data.Liable_From}
                        </GenericDataRow>
                    </div>
                </div>
                <div className="evidence-data-tables-container">
                    <GovernmentEvidenceTable data={data} />
                    <MarketingEvidenceTable data={data} />
                    {
                        isBdPlus &&
                        <ExperianEvidenceTable data={data} />
                    }
                </div>
                <div className="map-container">
                    <GoogleOpeningHoursTable
                        data={data}
                    />
                    <PropertyMap
                        address={data.SPID_Address}
                    />
                </div>
                <MatchingSpidDataTable
                    data={data} translations={translations} uuid={uuid}
                />
            </div>
        </GenericPageContainer>
    );
}